import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DiagnosticsMessage, DiagnosticsState } from './types';

const initialState: DiagnosticsState = {
    messages: [],
};

const DiagnosticsSlice = createSlice({
    name: 'diagnostics',
    initialState,
    reducers: {
        addMessage(state: DiagnosticsState, action: PayloadAction<DiagnosticsMessage>) {
            state.messages.push(action.payload);
        },
        clearMessages(state: DiagnosticsState) {
            state.messages = [];
        },
    },
});

export const { addMessage, clearMessages } = DiagnosticsSlice.actions;
export const diagnosticsReducer = DiagnosticsSlice.reducer;

export const diagnosticsMessageMock = createAction<DiagnosticsMessage>('diagnostics/diagnosticsMessageMock');
